import { useState } from 'react';

/**
 * Custom hook for managing modal open/close state.
 * Returns isOpen state and handleClose function.
 * 
 * @returns {Object} Object containing isOpen boolean and handleClose function
 */
export const useModalState = () => {
	const [isOpen, setIsOpen] = useState(true);

	const handleClose = () => {
		setIsOpen(false);
	};

	return { isOpen, handleClose };
};